// Elenco centralizzato delle pagine/sezioni del sito multi-pagina
export const PAGES = [
  { path: "/come-funziona", label: "Come funziona", desc: "Il processo, passo dopo passo." },
  { path: "/medici", label: "Medici", desc: "Generalisti e specialisti disponibili." },
  { path: "/anziani", label: "Anziani", desc: "Vicino ai tuoi genitori." },
  { path: "/pediatria", label: "Pediatria", desc: "Visite serene per i bambini." },
  { path: "/rsa", label: "RSA e strutture", desc: "La specialistica nelle strutture." },
  { path: "/altri-utilizzi", label: "Altri utilizzi", desc: "Farmacie, hotel, aziende." },
  { path: "/prezzi", label: "Prezzi", desc: "Un prezzo chiaro prima della conferma." },
  { path: "/faq", label: "Domande frequenti", desc: "Le risposte più cercate." },
  { path: "/lavora-con-noi", label: "Lavora con noi", desc: "Medici, infermieri, farmacie e strutture partner." },
  { path: "/contatti", label: "Contatti", desc: "Telefono, email e dove siamo." },
];

// Voci principali dell'header (con dropdown "Per chi è")
export const PRIMARY_NAV = [
  { label: "Come funziona", path: "/come-funziona" },
  { label: "Medici", path: "/medici" },
  { label: "Prezzi", path: "/prezzi" },
  { label: "RSA e strutture", path: "/rsa" },
];

export const AUDIENCE_NAV = [
  { label: "Anziani", path: "/anziani" },
  { label: "Pediatria", path: "/pediatria" },
  { label: "Altri utilizzi", path: "/altri-utilizzi" },
];
